import { SOCIAL_NETWORKS } from 'rebook/apps/base/components/social/constants';


export const ABOUT_MYBOOK_ITEMS = [
  {
    url: '/about/',
    text: 'О проекте',
  },
  {
    url: '/about/terms/',
    text: 'Условия использования',
  },
  {
    url: '/about/offer/',
    text: 'Публичная оферта',
  },
  {
    url: '/about/copyright/',
    text: 'Правообладателям',
  },
  {
    url: '/about/privacy_policy/',
    text: 'Политика конфиденциальности',
  },
  {
    url: '/about/email_agreement/',
    text: 'Согласие на получение рассылок',
  },
  {
    url: 'https://mybook.ru/l/help/',
    text: 'Помогите MyBook стать лучше',
    outerlink: true,
  },
];

export const ABOUT_SUBSCRIPTION_ITEMS = [
  {
    url: '/payments/',
    text: 'Подписка',
  },
  {
    url: '/about/payments/',
    text: 'Как оплатить',
  },
  {
    url: '/payments/activate_gift/',
    text: 'Ввести подарочный код',
  },
  {
    url: '/help/',
    text: 'Помощь',
  },
];

export const MENU_ITEMS = [
  {
    url: '/catalog/books/free/',
    text: 'Все бесплатные книги',
  },
  {
    url: '/account/edit/',
    text: 'Настройки',
    isForAuthenticatedUser: true,
  },
  {
    url: 'https://selfpub.ru/?utm_source=mybook',
    text: 'Издать свою книгу',
    outerlink: true,
  },
];

export const SOCIAL_PUBLICS = [
  {
    id: 1,
    name: SOCIAL_NETWORKS.FACEBOOK.name,
    icon: SOCIAL_NETWORKS.FACEBOOK.icon,
    url: 'https://www.facebook.com/MyBookRu',
  },
  {
    id: 2,
    name: SOCIAL_NETWORKS.VK.name,
    icon: SOCIAL_NETWORKS.VK.icon,
    url: 'https://www.vk.com/mybook_ru',
  },
  {
    id: 3,
    name: SOCIAL_NETWORKS.TWITTER.name,
    icon: SOCIAL_NETWORKS.TWITTER.icon,
    url: 'https://twitter.com/mybookru',
  },
  {
    name: SOCIAL_NETWORKS.ODNOKLASSNIKI.name,
    icon: SOCIAL_NETWORKS.ODNOKLASSNIKI.icon,
    url: 'http://www.ok.ru/knizhnykl',
    id: 4,
  },
  {
    id: 5,
    name: SOCIAL_NETWORKS.INSTAGRAM.name,
    icon: SOCIAL_NETWORKS.INSTAGRAM.icon,
    url: 'https://instagram.com/mybookru/',
  },
];

export const CONTACT_ITEMS = [
  {
    id: 0,
    url: 'tel:+78003332737',
    text: '8 800 333 27 37',
  },
  {
    id: 1,
    url: 'mailto:support@mybook.ru',
    text: 'support@mybook.ru',
  },
];
